<template>

    <div class="row mt-1">
        <div :class="firstColumnClass">
            <span v-bind:class="{'fw-bold': firstColumnStrong}">
                <slot name="number"></slot>
            </span>
        </div>
        <div :class="secondColumnClass">
            <span v-bind:class="{'fw-bold': secondColumnStrong}">
                <slot name="content"></slot>
            </span>
        </div>
    </div>

</template>

<script>

export default {
    components: {},

    props: {
        firstColumnStrong: {default: false},
        secondColumnStrong: {default: false},
        firstColumnClass: {default: 'col-sm-1'},
        secondColumnClass: {default: 'col-sm-11'},
    },

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
